import RowView from "components/RowView";
import SectionCard from "components/SectionCard";
import { fontSizes } from "appconstants";
import Text from "components/Text";
import Wrapper from "components/Wrapper";
import SettingsFunctional from "./index.function";
import InputField from "components/InputField";
import { Button } from "components/ui/button";
import { edit_primary_icon } from "asset/icons";
import { SettingsModal } from "./components";
import { Formik } from "formik";
import ErrorText from "components/ErrorText";
import { change_password_schema, change_password_validation_schema } from "../../validation_schema/change_password_validation_schema";

const Settings = () => {
  const { user, open, setOpen, onSubmit, user_loading } = SettingsFunctional();

  return (
    <Wrapper className="h-full">
      <Text text="Settings" size={fontSizes.h26} className="font-bold" />

      <div className="grid grid-cols-2 mt-6">
        <SectionCard title="Profile Detail">
          <RowView
            onClick={() => setOpen(true)}
            label="Name"
            value={user?.fullName}
            icon={edit_primary_icon}
          />
          <RowView label="Email" value={user?.email} className="border-0" />
        </SectionCard>
      </div>

      <SectionCard title="Change Password" className="mt-8 mb-4">
        <Formik
          initialValues={change_password_schema}
          validationSchema={change_password_validation_schema}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={(values, functions) => {
            onSubmit(values, functions.resetForm);
          }}
        >
          {({
            values,
            errors,
            setFieldValue,
            setFieldError,
            handleSubmit,
          }) => (
            <>
              <div className="flex gap-4 mb-4">
                <div className="w-full">
                  <InputField
                    label="Old Password"
                    required
                    value={values.oldPassword}
                    placeholder="Enter Old Password"
                    onChange={(val) => {
                      setFieldValue("oldPassword", val);
                      setFieldError("oldPassword", "");
                    }}
                  />
                  {errors.oldPassword && (
                    <ErrorText text={errors.oldPassword} />
                  )}
                </div>

                <div className="w-full">
                  <InputField
                    label="New Password"
                    required
                    value={values.newPassword}
                    placeholder="Enter New Password"
                    onChange={(val) => {
                      setFieldValue("newPassword", val);
                      setFieldError("newPassword", "");
                    }}
                  />
                  {errors.newPassword && (
                    <ErrorText text={errors.newPassword} />
                  )}
                </div>
              </div>

              <div className="w-full">
                <InputField
                  label="Confirm Password"
                  required
                  value={values.confirmPassword}
                  placeholder="Enter Confirm Password"
                  onChange={(val) => {
                    setFieldValue("confirmPassword", val);
                    setFieldError("confirmPassword", "");
                  }}
                />
                {errors.confirmPassword && (
                  <ErrorText text={errors.confirmPassword} />
                )}
              </div>

              <Button
                loading={user_loading}
                className="w-48 h-10 mt-7 mb-4"
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
            </>
          )}
        </Formik>
      </SectionCard>

      <SettingsModal
        open={open}
        onClose={() => setOpen(false)}
        fullName={user?.fullName}
      />
    </Wrapper>
  );
};

export default Settings;
